export const HELP_EMAIL = 'help@artkivebox.com'
export const OLD_HELP_EMAIL = 'help@artkiveapp.com'
